import styled from "styled-components";

export const StyledPortfolioImagesItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1.6rem;
`;
export const StyledPortfolioImagesItemImageWrapper = styled.div`
  width: 10.2rem;
  height: 5rem;
`;
